export default "__VITE_ASSET__Bujoyi1l__"